<template>
    <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import utils from "@/utils";
export default {
    computed: {
        ...mapGetters("Users", ["menus"]),
        breadcrumbs() {
            return [
                {
                    text: "Home",
                    disabled: false,
                    to: "#",
                },
            ];
        },
    },
    watch: {
        authUser: {
            immediate: true,
            handler(user) {
                const menuItem = this.$_.get(user, "homeUrl", "");
                const menuUrl = utils.menuUrl(menuItem);
                if (this.$_.has(menuUrl, "to")) {
                    this.$router.push({ path: menuUrl.to });
                }
                if (this.$_.has(menuUrl, "href")) {
                    window.location.replace(menuUrl.href);
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
</style>